import { Button, Col, Grid, Image, Row, Typography } from 'antd';

import ImageC from 'src/components/Image';

import classes from './index.module.less';

const GenerateAi = () => {
	const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes.pagehero}>
			<div className={classes['page-body-wrap']}>
				<div className="container">
					<Row>
						<Col md={24} sm={24} xs={24} lg={12} xl={12}>
							<div className={classes.imgbabyAI}>
								<ImageC
									src="/images/generateAi/img1.webp"
									width={xs ? 320 : 520}
									height={xs ? 260 : 420} />

							</div>
						</Col>
						<Col md={24} sm={24} xs={24} lg={12} xl={12}>
							<div className={classes.imgbabyText}>
								<p className={classes.title} style={{ marginBottom: '-5px' }}>
									Prediksi Wajah Si Kecil
								</p>
								<Typography className={classes.paragraph}>
									Penasaran seperti apa wajah Si Kecil👶 nanti? Cukup unggah foto Mama dan Papa, lalu lihat gambaran wajah Si Kecil sebagai prediksi seru selama masa penantian
								</Typography>

								<div className={classes.btnFooter}>
									<Button
										className={classes.btn}
										size="large"
										id="babyAI-coba-sekarang"
										href='/prediksi-wajah-bayi'
									>
										<span className={classes.btnContent}>
											<span className={classes.btnText}>Coba Sekarang  </span>
											<Image
												src="/images/generateAi/btn-icon.svg"
												alt="icon"
												width={24}
												height={24}
												preview={false}
												className={classes.btnIcon}
											/>
										</span>
									</Button>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default GenerateAi;
